function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1976d2",
      fillOpacity: 1
    },
    d: "M34.922 54c-2.203 2.453-5.375 4-8.922 4h-6c-6.617 0-12-5.383-12-12s5.383-12 12-12h6c3.547 0 6.719 1.547 8.922 4h9.398C41.227 30.945 34.187 26 26 26h-6C8.969 26 0 34.969 0 46s8.969 20 20 20h6c8.188 0 15.227-4.945 18.32-12ZM76 26h-6c-8.188 0-15.227 4.945-18.313 12h9.391c2.203-2.453 5.383-4 8.922-4h6c6.617 0 12 5.383 12 12s-5.383 12-12 12h-6c-3.54 0-6.719-1.547-8.922-4h-9.39C54.773 61.055 61.812 66 70 66h6c11.031 0 20-8.969 20-20s-8.969-20-20-20"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPending);
export default __webpack_public_path__ + "static/media/status-pending.98c712fb178024a3baf52cd15fac35fc.svg";
export { ForwardRef as ReactComponent };